export default {
  outlineHap: '0 0 0 2px #52D8D8',
};
